import MyBread from '../../components/Breadcrumbs'
import React, { Fragment, useEffect, useState, Dispatch, SetStateAction } from 'react'
import MaterialTable from 'material-table'
import { ThemeProvider, createTheme, CircularProgress } from '@mui/material';
import { useModal } from 'react-hooks-use-modal';
import { useForm, SubmitHandler } from "react-hook-form";
import { useAuth } from '../../hooks/use-auth';
import axios from 'axios';
import IdSearchButton from '../../components/IdSearchButton';
import config from 'config';
import { removeKeyWithValue } from 'utils';
import { DeletedContents } from 'styles/styles';
import { Wrapper, PageTitle, CreateNew, ModalStyle, FormLabel, FormInput, FormLabelInputWrapper, ModalTitle, ModalForm, ModalSubmit, LoadingContainer, ModalClose } from 'styles/styles';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

interface ParentProps {
	data: ParentDataProps[];
	selectedId: number;
	setSelectedId: Dispatch<SetStateAction<number>>;
	setIsParentDataInsert: Dispatch<SetStateAction<boolean>>;
}

interface ParentDataProps {
	process_id: number
	display_id: string
	name: string
	name_kana: string
	abbreviation: string
	available_time: string
	factory_breaking_id: string
	is_outsourcing: number
	equipment_id: string
	[key: string]: string | number;
}

const Parent = ({ data, selectedId, setSelectedId, setIsParentDataInsert }: ParentProps) => {
	const auth = useAuth();
	const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);
	//modal
	const [modalTitle, setModalTitle] = React.useState('');
	const [Modal, open, close, isOpen] = useModal('root', { preventScroll: true, });
	const { reset, register, handleSubmit, setValue, watch, formState: { errors } } = useForm<ParentDataProps>();
	const onSubmit: SubmitHandler<ParentDataProps> = async (submitData: ParentDataProps) => {
		let alertList: any[] = [];
		const requiredFields = parentArray.filter(obj => obj.required === true).map(obj => obj.field);
		requiredFields.forEach((key) => {
			if (submitData[key] === undefined || submitData[key] === '') {
				alertList.push(key)
			}
		});
		if (alertList.length) {
			let text = '';
			parentArray.forEach(item => {
				if (alertList.includes(item.field)) {
					text += `${item.title}を埋めてください。\n`;
				}
			});
			if (text !== '') {
				alert(text);
				throw new Error('必須項目が未入力です');
			}
		}
		submitData = removeKeyWithValue(submitData, '');
		const branchData = {
			display_id: submitData.display_id,
			process_id: submitData.process_id,
			equipment_id: submitData.equipment_id,
			name: submitData.name,
			name_kana: submitData.name_kana,
			abbreviation: submitData.abbreviation,
			available_time: submitData.available_time,
			factory_breaking_id: submitData.factory_breaking_id,
			is_outsourcing: submitData.is_outsourcing,
		}
		try {
			setIsSubmitDisable(true);
			if (!selectedId) {
				await axios.post(`/v0/factories/${auth.factoryId}/processes`, branchData, {
					headers: auth.authorizationHeader
				});
				window.alert("登録が完了しました");
			} else {
				await axios.patch(`/v0/factories/${auth.factoryId}/processes`, branchData, {
					headers: auth.authorizationHeader,
					params: { id: selectedId }
				});
				window.alert("変更が完了しました");
			}
			close();
			setIsParentDataInsert(true);
		} catch (error: any) {
			window.alert(error.response.data.error);
		}
		setIsSubmitDisable(false);
	};
	//modal end

	//arrayの生成
	const parentArray = [{ title: '', field: 'process_id' },
	{ title: '工程ID', field: 'display_id', default: 'process-1', type: 'alphanumeric', required: true },
	{ title: '工程名', field: 'name', default: '工程名', type: 'text', required: true },
	{ title: '工程名（カナ）', field: 'name_kana', default: '工程名（カナ）', type: 'text' },
	{ title: '略称', field: 'abbreviation', default: '略称', type: 'text' },
	{ title: '１日能力時間(分)', field: 'available_time', default: '0', type: 'number' },
	{ title: '', field: 'factory_breaking_id' },
	{ title: '', field: 'factory_breaking_is_deleted' },
	{ title: '休憩設定区分', field: 'factory_breaking_display_id', default: '', search: 'factory-breakings', disable: true },
	{ title: '内外作区分', field: 'is_outsourcing', type: 'checkbox' },
	{ title: '', field: 'equipment_id' },
	{ title: '', field: 'equipment_is_deleted' },
	{ title: '設備ID', field: 'equipment_display_id', default: '', search: 'equipments', disable: true }]
	const PAGE_TITLE = "工程"
	const defaultObj: any = {};
	for (const element of parentArray) {
		defaultObj[element.field] = element.default;
	}
	const columnsArray: any = [];

	function isConditionSatisfied(rowData: any, field: string): number | boolean {
		return (
			(parseInt(rowData.factory_breaking_is_deleted) && field === 'factory_breaking_display_id') ||
			(parseInt(rowData.equipment_is_deleted) && field === 'equipment_display_id')
		);
	}

	for (const element of parentArray) {
		if (element.title) {
			const title = element.title;
			const field = element.field;
			const tmpObj = {
				title: title,
				field: field,
				render: (rowData: any) => {
					if (isConditionSatisfied(rowData, field)) {
						return (
							<DeletedContents>
								{rowData[field]}
							</DeletedContents>
						);
					} else if (field === 'is_outsourcing') {
						if (parseInt(rowData.is_outsourcing)) {
							return (
								<CheckBoxIcon />
							);
						} else {
							return (
								<CheckBoxOutlineBlankIcon />
							);
						}
					} else {
						return rowData[field]
					}
				},
				cellStyle: {
					minWidth: 150,
					maxWidth: 150,
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis'
				}
			};
			columnsArray.push(tmpObj)
		}
	}

	//検索BOX
	const [selectedEquipmentContents, setSelectedEquipmentContents] = useState<any>('');

	useEffect(() => {
		setValue('equipment_id', selectedEquipmentContents.equipment_id);
		setValue('equipment_display_id', selectedEquipmentContents.display_id);
	}, [selectedEquipmentContents])

	const [selectedFactoryBreakingContents, setSelectedFactoryBreakingContents] = useState<any>('');

	useEffect(() => {
		setValue('factory_breaking_id', selectedFactoryBreakingContents.factory_breaking_id);
		setValue('factory_breaking_display_id', selectedFactoryBreakingContents.display_id);
	}, [selectedFactoryBreakingContents])

	const listItems = parentArray.map((element: any, index) => {
		if (element.title) {
			return (
				<Fragment key={index}>
					<FormLabelInputWrapper>
						<FormLabel htmlFor={element.field}>{element.title}</FormLabel>
						<FormInput {...register(element.field)}
							{...(element.type && { type: config.inputErrorMessage[element.type].type })}
							{...(element.type && { placeholder: config.inputErrorMessage[element.type].placeholder })}
							{...(element.type && { pattern: config.inputErrorMessage[element.type].pattern })}
							{...(element.type && { title: config.inputErrorMessage[element.type].title })}
							{...(element.required && { required: true })}
							{...(element.disable && { disabled: true })}
							{...(element.type && { maxLength: config.inputErrorMessage[element.type].maxLength })}
							{...(element.type === "number" && { max: config.inputErrorMessage[element.type].max })}
						/>
						{element.search === "equipments" ? <IdSearchButton search={element.search} setSelectedContents={setSelectedEquipmentContents} /> :
							element.search === "factory-breakings" ? <IdSearchButton search={element.search} setSelectedContents={setSelectedFactoryBreakingContents} /> : <></>
						}
					</FormLabelInputWrapper>
				</Fragment>
			)
		}
	});
	//カラムなど生成ここまで

	const defaultMaterialTheme = createTheme();
	const [pageSize, setPageSize] = React.useState(5);

	//IDから既存の値を呼び出し
	async function setModalValue(process_id: number) {
		if (!process_id) {
			reset(defaultObj);
			setModalTitle("新規作成")
		} else {
			//データの取得axios
			setSelectedId(process_id);
			const result: any = await axios.get(`/v0/factories/${auth.factoryId}/processes`, {
				headers: auth.authorizationHeader,
				params: { id: process_id }
			});
			reset(result.data[0]);
			setModalTitle("編集")
		}
	}

	const createNew = async () => {
		setSelectedId(0);
		await setModalValue(0);
		open();
	}

	return (
		<>
			<CreateNew onClick={createNew}>新規作成</CreateNew>
			<ThemeProvider theme={defaultMaterialTheme}>
				<MaterialTable
					title={PAGE_TITLE}
					columns={columnsArray}
					data={data}
					actions={[
						{
							icon: 'edit',
							tooltip: '編集する',
							onClick: async (event, rowData: any) => {
								event.preventDefault();
								try {
									await setModalValue(rowData.process_id);
									open();
								} catch (error) {
									console.log(error)
								}
							}
						},
						{
							icon: 'delete',
							tooltip: '削除する',
							onClick: async (event, rowData: any) => {
								event.preventDefault();
								const result = window.confirm(`${rowData.display_id}を削除しますか？`);
								if (result) {
									try {
										await axios.delete(`/v0/factories/${auth.factoryId}/processes`, {
											headers: auth.authorizationHeader,
											params: { id: rowData.process_id }
										});
										setIsParentDataInsert(true);
										setSelectedId(0);
									} catch (error: any) {
										window.alert(error.response.data.error);
									}
								}
							}
						}
					]}
					options={{
						actionsColumnIndex: -1,
						headerStyle: { whiteSpace: 'nowrap' },
						rowStyle: { overflowWrap: 'break-word' }
					}}
					onChangeRowsPerPage={(pageSize) => {
						setPageSize(pageSize);
					}}
					onRowClick={(event: any, rowData: any) => {
						event.preventDefault();
					}}
				/>
			</ThemeProvider>

			<Modal>
				<ModalStyle>
					<ModalTitle>{modalTitle}</ModalTitle>
					<ModalForm onSubmit={handleSubmit(onSubmit)}>
						{listItems}
						{isSubmitDisable ? (
							<LoadingContainer>
								<CircularProgress size={20} />
							</LoadingContainer>
						) : (
							<ModalSubmit type="submit" disabled={isSubmitDisable} />
						)}
					</ModalForm>
					<ModalClose onClick={close}>CLOSE</ModalClose>
				</ModalStyle>
			</Modal>
		</>
	)
}

export default function Processes() {
	const auth = useAuth();
	const [isParentDataInsert, setIsParentDataInsert] = useState<boolean>(false);
	const [parentData, setParentData] = useState<ParentDataProps[]>([]);
	const [selectedId, setSelectedId] = React.useState(0);

	useEffect(() => {
		try {
			axios.get(`/v0/factories/${auth.factoryId}/processes`, {
				headers: auth.authorizationHeader
			}).then((res: any) => {
				if (res.data.length) {
					setParentData(res.data);
				} else {
					setParentData([]);
				}
				setIsParentDataInsert(false)
			})
		} catch (err) {
			console.log(err)
		}
	}, [auth, isParentDataInsert]);

	return (
		<>
			<Wrapper>
				<MyBread />
				<PageTitle>工程マスタ</PageTitle>
				<Parent data={parentData} selectedId={selectedId} setSelectedId={setSelectedId} setIsParentDataInsert={setIsParentDataInsert} />
			</Wrapper>
		</>
	)
}